<template>
    <div>
        <div v-if="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.prevent.native="onSubmit('form')">
                <el-row :gutter="15">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Barcode" prop="barcode">
                            <el-input v-model="form.barcode" class="input-select">
                                <el-select v-model="form.barcodeType" slot="append" placeholder="Select barcode type">
                                    <el-option label="EAN" value="EAN"></el-option>
                                    <el-option label="UPC" value="UPC"></el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Color">
                            <el-input v-model="form.color"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="15">
                    <el-col :xs="12" :sm="12" :md="6">
                        <el-form-item label="Width">
                            <el-input v-model="form.width">
                                <template slot="append">cm</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6">
                        <el-form-item label="Height">
                            <el-input v-model="form.height">
                                <template slot="append">cm</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6">
                        <el-form-item label="Length">
                            <el-input v-model="form.length">
                                <template slot="append">cm</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6">
                        <el-form-item label="Net weight">
                            <el-input v-model="form.weight">
                                <template slot="append">grams</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </div>
        <div v-else>
            <el-button type="primary" size="mini" @click="dialogVisible = true">
                Add Variant
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                barcode: null,
                barcodeType: 'EAN',
                color: null,
                width: null,
                height: null,
                length: null,
                weight: null,
            },
            rules: {
                'barcode': [
                    { required: true, message: 'Enter the product barcode.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        productId: {
            required: true,
            type: String,
        },
    },

    methods: {
        onSubmit(form) {
            this.loading = true
            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/product-variants`, {
                        barcode_value: this.form.barcode,
                        barcode_type: this.form.barcodeType,
                        color: this.form.color,
                        product_id: this.productId,
                        width: this.form.width,
                        height: this.form.height,
                        length: this.form.length,
                        weight: this.form.weight,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.dialogVisible = false
                this.$refs[form].resetFields()
                this.$emit('create')
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.dialogVisible = false
            this.$refs[form].resetFields()
        },
    },
}
</script>

<style>
.input-select .el-input-group__append {
    width: 100px;
    padding: 0;
}

.input-select .el-select {
    margin: -10px 0;
    text-align: right;
}
</style>
